import { render, staticRenderFns } from "./MetadataView.vue?vue&type=template&id=2bf2ac24&scoped=true"
import script from "./MetadataView.vue?vue&type=script&lang=ts"
export * from "./MetadataView.vue?vue&type=script&lang=ts"
import style0 from "./MetadataView.vue?vue&type=style&index=0&id=2bf2ac24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf2ac24",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,AnalyzerLogo: require('/app/components/AnalyzerLogo.vue').default,AnalyzerList: require('/app/components/Repository/AnalyzerList.vue').default,LastRunInfo: require('/app/components/Repository/LastRunInfo.vue').default})
